import script from "./messageTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./messageTable.vue?vue&type=script&setup=true&lang=ts"

import "./messageTable.vue?vue&type=style&index=0&id=4e0739b6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0739b6"]])

export default __exports__